import {http} from '~/services/http';

import guestFormData, {
    guestPersonalDetails,
    guestEmergencyContact,
    guestTravel,
    guestHotelRooms,
    guestSpecialRequirements
} from '~/services/adapters/guest';

import {updateInvitationAction} from './invitation'

import {
    LOAD_GUESTS,
    UPDATE_GUEST,
    SET_ACTIVE_GUEST,
    SET_ACTIVE_STEP,
    SET_STEPS,
    UPDATE_GUEST_FORM,
    ADD_GUEST_DOCUMENT, UPDATE_INVITATION
} from './types';
import {redirectAction} from "~/redux/actions/redirect";

export const loadGuestsAction = () => async (dispatch) => {

    const response = await http.get('/guests');

    dispatch({
        type: LOAD_GUESTS,
        payload: response?.data || []
    });
};

export const updateGuestAction = (guest) => (dispatch) => {

    dispatch(updateInvitationAction(guest.invitation));

    dispatch({
        type: UPDATE_GUEST,
        payload: guest
    });
};

export const setActiveGuestAction = (key) => (dispatch) => {

    dispatch({
        type: SET_ACTIVE_GUEST,
        payload: key
    });
};

export const setStepsAction = (steps) => (dispatch) => {

    dispatch({
        type: SET_STEPS,
        payload: steps
    });
};

export const setActiveStepAction = (step) => (dispatch) => {

    dispatch({
        type: SET_ACTIVE_STEP,
        payload: step
    });
};

export const nextStepAction = () => (dispatch, getState) => {

    const state = getState();
    const steps = Object.keys(state.guests.steps);
    const current = state.guests.activeStep[state.guests.activeGuest];
    const index = steps.indexOf(current);
    const nextIndex = index + 1;

    if (steps[nextIndex]) {
        dispatch(setActiveStepAction(steps[nextIndex]));
        return;
    }

    const nextGuest = state.activeGuest + 1;

    if (state.guests.list[nextGuest] && state.guests.list[nextGuest].started) {
        dispatch(setActiveGuestAction(nextGuest));
        dispatch(setActiveStepAction('personal_details'));
    } else {
        dispatch(redirectAction('/preview'));
    }
};

export const prevStepAction = () => (dispatch, getState) => {

    const state = getState();
    const steps = Object.keys(state.guests.steps);
    const current = state.guests.activeStep[state.guests.activeGuest];
    const index = steps.indexOf(current);
    const prevIndex = index - 1;

    if (steps[prevIndex]) {
        dispatch(setActiveStepAction(steps[prevIndex]));
        return;
    }
};

export const updateGuestForm = (form) => (dispatch) => {

    dispatch({
        type: UPDATE_GUEST_FORM,
        payload: form
    });
};

export const startGuestProgress = (id) => async (dispatch, getState) => {

    const { currentLanguage } = getState()?.translations;

    const requestOptions = {
        headers: {
            "Content-Language": currentLanguage.code
        }
    }

    try {

        const res = await http.post('/guests/' + id + '/start', requestOptions);

        dispatch(updateGuestAction(res.data));

        return res;

    } catch (error) {
        console.log(error);
        throw error.response;
    }
};

export const stopGuestProgress = (id) => async (dispatch, getState) => {

    const { currentLanguage } = getState()?.translations;

    const requestOptions = {
        headers: {
            "Content-Language": currentLanguage.code
        }
    }

    try {

        const res = await http.post('/guests/' + id + '/stop', requestOptions);

        dispatch(updateGuestAction(res.data));

        return res;

    } catch (error) {
        console.log(error);
        throw error.response;
    }
};

export const saveGuestPersonalDetails = (id, form) => async (dispatch, getState) => {

    const { currentLanguage } = getState()?.translations;

    const requestOptions = {
        headers: {
            "Content-Language": currentLanguage.code
        }
    }

    try {
        const res = await http.put('/guests/' + id, form, requestOptions);

        dispatch(updateGuestAction(res.data));

        const data = guestPersonalDetails(res.data);
        dispatch(updateGuestForm(data));

        return res;

    } catch (error) {
        console.log(error);
        throw error.response;
    }
};

export const saveGuestRequirements = (id, form) => async (dispatch, getState) => {

    const { currentLanguage } = getState()?.translations;

    const requestOptions = {
        headers: {
            "Content-Language": currentLanguage.code
        }
    }

    try {
        const res = await http.post('/guests/' + id + '/requirements', form, requestOptions);

        dispatch(updateGuestAction(res.data));

        const data = guestSpecialRequirements(res.data);
        dispatch(updateGuestForm(data));

        return res;

    } catch (error) {
        console.log('error', error);
        throw error.response;
    }
};

export const saveGuestEmergencyContact = (id, form) => async (dispatch, getState) => {

    const { currentLanguage } = getState()?.translations;

    const requestOptions = {
        headers: {
            "Content-Language": currentLanguage.code
        }
    }

    try {
        const res = await http.post('/guests/' + id + '/emergency_contact', form, requestOptions);

        dispatch(updateGuestAction(res.data));

        const data = guestEmergencyContact(res.data);
        dispatch(updateGuestForm(data));

        return res;

    } catch (error) {
        console.log('error', error);
        throw error.response;
    }
};

export const saveGuestHotelRooms = (id, form) => async (dispatch, getState) => {

    const { currentLanguage } = getState()?.translations;

    const requestOptions = {
        headers: {
            "Content-Language": currentLanguage.code
        }
    }

    try {
        const res = await http.post('/guests/' + id + '/hotel_rooms', form, requestOptions);

        dispatch(updateGuestAction(res.data));

        const data = guestHotelRooms(res.data);
        dispatch(updateGuestForm(data));

        return res;

    } catch (error) {
        console.log('error', error);
        throw error.response;
    }
};

export const saveGuestTravel = (id, form) => async (dispatch, getState) => {

    const { currentLanguage } = getState()?.translations;

    const requestOptions = {
        headers: {
            "Content-Language": currentLanguage.code
        }
    }

    try {

        const res = await http.post('/guests/' + id + '/travel', form, requestOptions);

        dispatch(updateGuestAction(res.data));

        const data = guestTravel(res.data);
        dispatch(updateGuestForm(data));

        return res;

    } catch (error) {
        console.log('error', error);
        throw error.response;
    }
};

export const removeGuestDocument = (id) => async (dispatch) => {

    try {

        const res = await http.delete('/guests/documents/' + id);
        dispatch(updateGuestAction(res.data));

        return res;

    } catch (error) {
        throw error.response;
    }
};
